import { getFileApiCall, getFileBlobApiCall } from "./tokenService";

export const getAttachment = (id: string): Promise<string> => {
    return getFileApiCall("api/attachment?id=" + id);
};

export const download = (id: string, companyId: string): Promise<string> => {
    return getFileApiCall("api/download?id=" + id + "&companyId=" + companyId);
};

export const downloadBlob = (id: string, companyId: string): Promise<Blob> => {
    return getFileBlobApiCall("api/download?id=" + id + "&companyId=" + companyId);
};